export default __webpack_public_path__ + "static/media/mn_tea_head_3.e0c46eb4.png";